import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"aria-label":_vm.ariaLabel},on:{"click":_vm.toggle}},[(_vm.course.isFavorite)?_c(VIcon,{attrs:{"color":"favoriteStar"}},[_vm._v(" mdi-star ")]):_c(VIcon,[_vm._v(" mdi-star-outline ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }